:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._sectionsReorganizeExp_y31x0_7 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; }
  ._sectionsReorganizeExp_y31x0_7 ._spacerHandle_y31x0_14 {
    pointer-events: auto;
    position: relative;
    height: 12px;
    background-color: #116dff;
    margin: 0 auto;
    cursor: row-resize;
    display: flex;
    align-items: center;
    justify-content: center; }
  ._sectionsReorganizeExp_y31x0_7 > ._sectionSeparators_y31x0_24 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    shape-rendering: crispEdges; }
    ._sectionsReorganizeExp_y31x0_7 > ._sectionSeparators_y31x0_24 > ._sectionSeparator_y31x0_24 {
      stroke-width: 0.5px;
      stroke: #bcbcbc;
      stroke-dasharray: 4px 4px; }
